import React from 'react'
import Button from '../../../Components/commonButton/commonButton'
import Api from '../../../services/api'
import Alert from '../../../Components/alert/Alert'
import ReadOnlyTextField from '../../../Components/readOnlyTextField/readOnlyTextField'
import Select from '../../../Components/select/select'
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css";

export default class DelFactory extends React.Component {
  state = {factorys: [],
  factorysID: [],
  code:null, 
  description: '', 
  id: 0,
  message: "",
  reload:false,
  show:false,
  notification: false,
  notification_type: 'success',
  notification_message: ''}

  componentDidMount() {
    Api.get('/factorys/').then((resp) => {
      let arr = []
      resp.data.forEach(element => {
        arr.push({ value: element.id, label:element.description })
      })
      this.setState({ factorys: arr,factorysID:[...resp.data] })
    })
  }

  SelectFactory = (childData) => {
    const {description,id} = this.state.factorysID.find(v => v.id === childData)
    this.setState({description,id,code:id})    
  }

  sendData = (id) => {
    if(id > 0){
      Api.delete(`/factorys/${id}`, {
        description: this.state.description
      }).then(resp => {
        this.setState({notification: true, notification_message: "Planta deletada com sucesso!"});
          setTimeout(()=>{
            return window.location.reload();
          },2000)
      }).catch((error) => {
        let message = "" + error.message;

        if(error.response.status == 401){
          message = "Erro ao deletar! Um departamento depende desse registro.";
        }

        this.setState({ message: message, show: true })
          
      })
    }else{
      this.setState({ message: "Necessário preencher todos os campos.", show: true })
    }
  }

  changeValue      = (value) => {this.setState({ description: value.target.value })}
  callbackfunction = () => { this.setState({ show: false }) }

  render() { 
    let { show, message, reload, notification, notification_message, notification_type } = this.state;
    return (
      <div className='box'>
        {notification == true ? (<><Notification message={notification_message} type={notification_type}></Notification><Loading></Loading></>) : (<></>)}
        <div className='cont_del_fac form'>
        <h4>Deletar Planta</h4>
          {show ? <Alert show={show} message={message} parentCallback={this.callbackfunction} reload={reload} /> : null}
          <div className='inputs'>
            <div className='select element'><Select autoSelect={true} id='drop1' label="Selecionar Planta" arrData={this.state.factorys} handleSelect={this.SelectFactory} /></div>
            <div className='element'><ReadOnlyTextField showValue={this.state.description} title="Descrição" /></div>
            <div className='element'><ReadOnlyTextField showValue={this.state.code} title="Código" /></div>
          </div>
          <div className='delFacBtn submitButton'><Button icon="del" title="Deletar" parentCallback={() => this.sendData(this.state.id)} /></div>
        </div>
      </div>
    );
  }
}